import { useTranslation } from 'react-i18next';
import { TableSkeleton } from '@/components/table-skeleton';
import { useToastContext } from '../../providers/toast';
import { FormEditorModal } from './FormEditorModal';
import FormList from './FormList';
import { type FormListItem, useFormEditor } from './hooks';

const FormPage = () => {
  const { t } = useTranslation();
  const { showToast } = useToastContext();
  const editor = useFormEditor();

  const handleOpenCreate = () => {
    editor.openCreate();
  };

  const handleOpenEdit = async (form: FormListItem) => {
    await editor.openEdit(form);
  };

  const handleShareComplete = () => {
    showToast(t('formPage.response.linkCopied'), 'success');
  };

  if (editor.formsLoading) {
    return <TableSkeleton columns={8} page showAction />;
  }

  return (
    <>
      <FormList
        forms={editor.forms}
        labels={editor.labels}
        isDeleting={editor.isDeleting}
        onCreateClick={handleOpenCreate}
        onEdit={handleOpenEdit}
        onShare={handleShareComplete}
        onDelete={(form) => editor.handleDelete(form.id)}
      />

      <FormEditorModal editor={editor} />
    </>
  );
};

export default FormPage;
